// extracted by mini-css-extract-plugin
module.exports = {"button":"MessageFormNoteButton_button__2Hy0e","svgPath":"MessageFormNoteButton_svgPath__dQ7Eu","buttonWrapper":"MessageFormNoteButton_buttonWrapper__2hz-p"};